<template>
  <!-- 只有文本域的弹框 -->
  <el-dialog class="dialog-area" :append-to-body="true" :visible.sync="dialogVisible" width="420px">
    <div class="content">
      <h1 class="title">
        <span class="m-info" v-if="pageType==='ok'">同意</span>
        <span class="m-danger" v-if="pageType==='refuse'">拒绝</span>
        {{title}}
      </h1>
      <el-form class="g-form-grid" ref="form" :model="form" :rules="rules">
        <el-form-item :prop="isNeedValid?'reason':''">
          <el-input
            type="textarea"
            v-model="form.reason"
            placeholder="请输入原因"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="footer tc mt-30">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">
          <span v-if="pageType=='ok'">同意</span>
          <span v-if="pageType=='refuse'">拒绝</span>
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    approveTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loadingSave: false,
      isNeedValid: false, // 是否需要校验
      form: {
        reason: ''
      },
      rules: {
        reason: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      title: '',
      pageType: '', //refuse 拒绝 ok 同意 comment 评论
      detailId: ''
    }
  },
  methods: {
    init(detailId, type) {
      this.loadingSave = false
      this.detailId = detailId
      this.pageType = type //refuse 拒绝 ok 同意
      this.setTitle()
      this.form = {
        reason: ''
      }

      this.dialogVisible = true

      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
    setTitle() {
      switch (this.pageType) {
        case 'refuse':
          this.title = this.approveTitle
          this.isNeedValid = true
          break
        case 'ok':
          this.title = this.approveTitle
          this.isNeedValid = false
          break
      }
    },
    fromSubmit(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.sendApproval()
        }
      })
    },
    // 审批通过、拒绝
    sendApproval() {
      this.$http
        .post('/activitynew/team/common/approval', {
          id: this.detailId,
          approvalInfo: this.form.reason,
          approveStatus: this.pageType === 'ok' ? '1' : '2' // 1 通过  2 拒绝
        })
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            if (this.pageType === 'ok') {
              this.$message.success('审批通过成功')
            } else if (this.pageType === 'refuse') {
              this.$message.success('审批拒绝成功')
            }
            this.dialogVisible = false
            this.$emit('closePanel')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-area {
  .content {
    margin-top: -30px;
    .title {
      font-size: 16px;
      font-weight: normal;
    }
  }
}
</style>

